import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ProjectService } from 'src/app/_services/project/project.service';
import { UserService } from 'src/app/_services/user/user.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { Router, ActivatedRoute } from '@angular/router';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';

@Component({
  selector: 'app-sub-project-list',
  templateUrl: './sub-project-list.component.html',
  styleUrls: ['./sub-project-list.component.scss']
})
export class SubProjectListComponent implements OnInit {
  projectForm
  // row data and column definitions
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
  tenantId: string;
  userDetails: any;
  selectedFile: File;
  jsonData: any;
  gridApi: any;
  gridColumnApi: any;
  form: FormGroup;
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  projectId: any;
  currentProjectId: any;
  parentProjectId: any;
  isAdministrator: boolean = false;

  constructor(
    private projectService: ProjectService,  
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private storageService: LocalStorageService,
    private router: Router
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();  

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });
    
    this.projectForm = new FormGroup({
      customer: new FormControl(''),
      brand: new FormControl(''),
      currentModel: new FormControl(''),
      segment: new FormControl(''),
      projectCode: new FormControl(''),
      roughBudgetIndication: new FormControl(''),
      marketPositioning: new FormControl(''),
      platform: new FormControl(''),
      productionSites: new FormControl(''),
      lifecycles: new FormControl(''),
      lifecycleVolume: new FormControl(''),
      projectName: new FormControl(''),
      competitors: new FormControl(''),
      projectDescription: new FormControl(''),
      salesManager: new FormControl(''),
      quotationManager: new FormControl(''),
      projectManager: new FormControl(''),
      projectController: new FormControl(''),
      rfqDate: new FormControl(''),
      quotationDate: new FormControl(''),
      decisionDate: new FormControl(''),
      projectEnterMs: new FormControl(''),
      sop: new FormControl(''),
      eop: new FormControl(''),
      totalHours: new FormControl(''),
      remainingHours: new FormControl(''),
    })
    
   }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.isAdministrator = this.userDetails.roles.includes('RoleAdministrator');
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.parentProjectId = this.currentProjectId;

    this.getSubProjects();
  }

  getSubProjects() {
    if(this.isAdministrator){
      this.projectService.getSubProjects(this.parentProjectId).subscribe((response: any) => {
        this.rowData = response;
      });
    } else{
      let ignoreArchived : boolean = false;
      this.projectService.getSubProjectByUserId(this.userDetails.id, this.parentProjectId, ignoreArchived).subscribe((response: any) => {
        this.rowData = response;
      });
    }
  }

  openProjectTab(param) {
    this.router.navigate([this.tenantId + `/dashboard/project/project-list/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }  

  // create column definitions  
  private createColumnDefs() {
    return [
      {
        headerName: "Project Name",
        field: "projectName",
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: "Project Code",
        field: "projectCode",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Customer",
        field: "customer",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Project Manager",
        field: "projectManager",
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "% of Completion",
        field: "percentWorkCompleted",
        filter: true,
        editable: false,
        sortable: true,
        hide: false
      },
      {
        headerName: "ProjectStatus",
        field: "projectStatus",
        hide: true,
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: "Total Hours",
        field: "totalHours",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: "Remaining Hours",
        field: "remainingHours",
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      }
    ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }


  onCellClicked(e: any) {
    this.router.navigate([this.tenantId + '/dashboard/project/sub-project', { id: e.data.id}]);
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }    
  }

  private deleteGridRow(params: any) {
    this.projectService.deleteProject(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

  deleteSubProjectList() {
    let ids = [];
    for (let item of this.selectedCheckboxData) {
      ids.push(item.id)
    }
    console.log("ids",ids);
    let idsObj = {
      "ids": ids
    }
    this.projectService.deleteBulkSubProject(idsObj).subscribe(() => {
      this.getSubProjects();
      this.selectedCheckboxData = []
      $('#closeModalDeleteProject').trigger("click");
    });
  }

  openSubProject() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list/sub-project'], { queryParams: { parentId: this.parentProjectId } });
  }

  updateSubProject() {
    let currentProjectId = this.selectedCheckboxData[0].id; 
    this.router.navigate([this.tenantId + '/dashboard/project/project-list/sub-project'], { queryParams: { projectID: currentProjectId, parentId: this.parentProjectId } });
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].projectName}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].projectName}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].projectName}`;
    }
  }

  backToMyProject() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list/myproject']);
  }

}
